import { useDispatch } from 'react-redux'
import { addModal } from '@e3dc-react/shell/State/Modals/ModalActions'
import { ChartType, ChartView, CustomLayout, LoadingState } from '../Libs/chart-kit/shared/utils/chartModel'
import { UserData, UserLevel } from '../State/User/UserModel'
import { Layouts } from 'react-grid-layout'
import { Actuator } from '../Libs/smart-home/models/smart-home.model'
import { CompanyInvite } from 'src/Libs/company-settings/components/InviteEditor'
import type { ToggleIdlePeriodDialogProps } from 'src/Libs/smart-charge'
import { InstallationAccessInviteDialogProps } from 'src/Libs/installation-rights-management'
import { InstallationAccessSettingsDialogProps } from 'src/Libs/installation-rights-management/components/dialogs/InstallationAccessSettingsDialog'
import { SimpleTextDialogProps } from 'src/Elements/Dialogs'
import { HotWaterSupplyDialogProps } from 'src/Libs/smart-home/components/dialogs/HotWaterSupplyDialog'
import {
  ShopMoreInfoModalProps,
  ShopLeavingConfirmationModalModelProps,
  ShopTransformerModalProps,
  ShopRetrofitBatteryModalProps,
  ShopBillingAndShippingAddressModalProps,
  ShopNewShippingAddressModalProps,
  ShopUpdateSystemConfigurationModalProps,
  ShopSaveSystemConfigurationModalProps,
  ShopRetrofitBatterySingleProductModalProps,
  ShopOrderHistoryDetailsModalProps,
  ShopAdminModalProps,
  ShopHintModalProps,
  ShopAdditionalProductsModalProps,
} from 'src/Libs/shop'
import { DeviceInfoForStatement } from 'src/Libs/installation-statement/components/Modals/InstallationStatementDialog'
import { CompanyShowroomProps } from 'src/Libs/company-settings/components/CompanyShowroomModal'
import { NotificationMessageModalProps } from 'src/Libs/notifications/components/NotificationMessageModal'
import { PowerPriceChartModalProps } from 'src/Libs/dashboard-widgets/widgets/dynamic-power-price/power-price-chart/PowerPriceChartModal'
import { ManufacturerConnectionTermsProps } from 'src/Libs/e-mobility/vehicle-integration/components/manufacturer-list/ManufacturerConnectionTermsDialog'
import { ChargeModalProps } from 'src/Libs/e-mobility/vehicle-integration/components/state-of-charge/ChargeModal'
import { AssignManagerDialogProps } from 'src/Libs/company-settings/components/AssignManagerDialog'
import { ImagePreviewProps } from 'src/Elements/Documents/ImagePreviewModal'
import {
  ShopProductImageModalProps,
  ShopPromotionCodeModalProps,
  ShopSmartMeterDocumentUploadModalProps,
  ShopSmartMeterModalProps,
} from 'src/Libs/shop/models/shop-modal-props.model'
import { InstallationAccessRequestDialogProps, RenameInstallationModalProps } from 'src/Libs/installations'
import { OwnerAccessRequestDialogProps, InstallationAccessRightDialogProps } from 'src/Libs/installation-rights-management/components'
import { WallboxWeekDaysDialogProps } from 'src/Libs/wallboxes/components'
import { DashboardEditorProps } from 'src/Libs/dashboard/components/DashboardEditor'
import { ExtensionDetailsProps, ExtensionDeleteConnectionModalProps, SmartMeterRecommendationModalProps } from 'src/Libs/installation-extensions'
import { CookieModalProps } from 'src/Elements/Framework/CookieModal'
import { TestRunDetailsModalProps } from 'src/Libs/installation-details/components/system-details/modals'
import {
  ChangeInstallationOwnerModalProps,
  UpdateWarrantyDialogProps,
  EditAccessStartAtModalProps,
} from 'src/Libs/installation-details/components/modals'
import { GrantCompanyAccessModalProps } from 'src/Libs/installation-details/components/companies-with-access/modals'
import { GrantInstallerAccessModalProps } from 'src/Libs/installation-details/components/installers-with-access'
import { ChangeLocationDialogProps } from 'src/Libs/installation-details/components'
import { ChartProps } from 'src/Libs/chart-kit/shared/components/Chart'
import { ChartSettings } from 'src/Libs/chart-kit'
import { DynamicTariffSettingsDateRangeModalProps } from 'src/Libs/dynamic-tariff-settings/components/modal'
import { AmazonCodeDialogProps } from 'src/Libs/referral'
import {
  CategoryEditorProps,
  DeleteCategoryProps,
  DownloadItemEditorProps,
  MoveDownloadItemEditorProps,
  ProtectedFileDialogProps,
} from 'src/Libs/downloads/components'
import { UploadFileDialogProps } from 'src/Libs/downloads/components/upload-file/UploadFileDialog'
import { ChargingCardDetailsModalProps, ChargingCardModel, LinkedWallboxesOverviewDialogProps } from 'src/Libs/e-mobility/charging-cards'
import { WallboxModel } from 'src/Libs/e-mobility/wallboxes'
import {
  ChargingSessionModel,
  ChargingSessionModelV1,
  ExportSessionsPayload,
  ReimbursementExportSessionsDialogProps,
} from 'src/Libs/e-mobility/charging-sessions'
import { WallboxHardwareModel } from 'src/Libs/wallboxes/models'
import { ExportChargingCardEditorProps } from 'src/Libs/e-mobility/emobility-charging-cards/export-charging-card/ExportChargingCardEditor'
import { EMobilityChargingCardsDataModel } from 'src/Libs/e-mobility/emobility-charging-cards/models/e-mobility-charging-cards-models'
import { ManageModeConfirmationDialogProps } from 'src/Libs/e-mobility/charging-cards/components/link-wallboxes/ManageModeConfirmationDialog'
import { EditTariffDialogProps } from 'src/Libs/e-mobility/tariffs'
import { EditBadgeDialogProps, InstallationDeleteDialogProps, InstallationSaveDialogProps } from 'src/Libs/flow/advanced-settings/components/Dialogs'
import { ReplaceFileDialogProps } from 'src/Libs/downloads/components/download-item-editor/ReplaceFileDialog'
import {
  ModbusTcpPairingDialogProps,
  EebusPairingDialogProps,
  EnterOcppPasswordDialogProps,
} from 'src/Libs/flow/advanced-settings/charging-stations/components/Dialogs'
import { HeatpumpPairingDialogProps } from 'src/Libs/flow/advanced-settings/heatpump/components/Dialogs/HeatpumpPairingDialog'
import { Htc320hIoPairingDialogProps, MyPvPairingDialogProps } from 'src/Libs/flow/advanced-settings/io/components/Dialogs'
import {
  AddDeviceDialogProps,
  EmcPairingDialogProps,
  ActivateModbusTcpServerDialogProps,
  InstallationPairingDialogProps,
  SmartMeterGatewayPairingDialogProps,
} from 'src/Libs/flow/advanced-settings/overview'
import { MeterPairingDialogProps } from 'src/Libs/flow/advanced-settings/powermeter/components/Dialog/MeterPairingDialog'
import { StoragePairingDialogProps } from 'src/Libs/flow/advanced-settings/storage/components'
import {
  HoldingTimeEditorDialogProps,
  PhaseManagementEditorDialogProps,
} from 'src/Libs/flow/end-user-settings/wallbox/components/advancedEvseSettings'
import { ChargingScheduleEditorDialogProps } from 'src/Libs/flow/end-user-settings/wallbox/components/chargingPriority'
import { BoilerScheduleEditorDialogProps } from 'src/Libs/flow/end-user-settings/boiler/components'
import { ReasonDialogProps } from 'src/Components/modals/ReasonDialog'
import { z } from 'zod'
import { ChargingSessionDetailsDialogV1FlowProps } from 'src/Libs/flow/dialogs/ChargingSessionDetailsDialog'
import { useCallback } from 'react'
import { FarmParticipantSelectorProps } from 'src/Elements/Farm/FarmParticipantSelector'
import { ScanNetworkDialogProps } from 'src/Libs/installations/components/new-installation/configuration'
import { PowerMeterScanDialogProps } from 'src/Libs/installations/components/new-installation/configuration/power-meters/PowerMeterScanDialog'
import type { DocumentLanguageType } from 'src/State/Documents/DocumentModel'

type UserProps = {
  userId?: number
}

export interface IPinEditorProps {
  userId: number
}

export interface ProjectNameEditorProps {
  projectName?: string
  setProjectName: (value?: string) => void
}

interface PvModuleProps {
  pvModuleId?: number
}

interface BatteryExportModuleProps {
  batteryExportModuleId?: number
}

interface PasswordEditorProps {
  user: UserData
}

export interface SystemChartProps {
  chartId?: number | string
  chartProps?: ChartProps
  views?: Record<ChartView, ChartType>
  name?: string
  ticks?: number[]
  handleSaveChart?: (props: ChartSettings) => void
  serialNumber?: string
  loadingState?: LoadingState
}

export interface ConfirmationModalProps {
  text?: string
  title: string
  buttonText: [cancelButtonText: string, confirmButtonText: string]
  onConfirm: (onClose: () => void) => Promise<void> | void
  onCancel?: (onClose: () => void) => Promise<void> | void
  isLoading?: boolean
  renderAdditionalButtonContent?: (onClose: () => void) => React.ReactElement
  children?: React.ReactNode
  showChildrenOnTop?: boolean
}

export interface InformationModalProps {
  textKey: string
  title: string
  buttonText?: string
  open?: boolean
}

interface InstallationAddressEditorProps {
  installationId: number
}

interface ChartLayoutEditorProps {
  defaultAndCustomCharts: CustomLayout[]
  customLayout: Layouts
}

type OpenFarmParticipantSelectorProps = Pick<FarmParticipantSelectorProps, 'selectedOptionStorageId'>

interface AssignedUsersProps {
  companyId: number
}

interface AssignedSystemsProps {
  userId: string
}

interface ActuatorEditorProps {
  actuators?: Actuator[]
  onConfirm: (name: string, type: number, index: number, group: boolean, onClose: () => void) => void
}

interface InviteEditorProps {
  onSave: (invite: CompanyInvite) => void
  size: string
  title: string
  description?: string
}

export type CompanyShowroomModalProps = Omit<CompanyShowroomProps, 'onClose' | 'place'>

interface DocumentCategoryProps {
  categoryId?: number
  parentCategoryId?: number
  language?: DocumentLanguageType
  parentLevels?: UserLevel[]
}

interface DocumentsProps {
  parentCategoryId?: number
  language?: DocumentLanguageType
  documentId?: number
  parentLevels?: UserLevel[]
}

interface InstallationDocumentUploadProps {
  installationId: number
}

interface AddWallboxProps {
  onConfirm: (name: string, type: number, index: number, group: boolean, onClose: () => void) => void
  storageSerialNr: string
}
type SmartChargeToggleIdlePeriodDialogProps = Pick<ToggleIdlePeriodDialogProps, 'onConfirm' | 'processingType'>
type InviteNewAccessToInstallationProps = Pick<InstallationAccessInviteDialogProps, 'onConfirm' | 'isInvitingOwner'>
type CommonSimpleTextDialogProps = Pick<
  SimpleTextDialogProps,
  'onConfirm' | 'value' | 'title' | 'abortLabel' | 'description' | 'confirmLabel' | 'confirmTitle' | 'confirmText'
>
type InstallationAccessSettingsProps = Pick<InstallationAccessSettingsDialogProps, 'value' | 'installation' | 'afterDataUpdate'>

interface InstallationStatementProps {
  installation: DeviceInfoForStatement
}

interface EditChargingCardProps {
  data: EMobilityChargingCardsDataModel
  serialNo: string
}

interface ChargingSessionDetailsV1Props {
  session: ChargingSessionModelV1
  wallboxes: WallboxHardwareModel[]
}
type ExportChargingCardProps = Pick<ExportChargingCardEditorProps, 'rfid' | 'vehicleName' | 'chargingCard' | 'storageId'>

type ChargingSessionDetailsV1FlowProps = Pick<ChargingSessionDetailsDialogV1FlowProps, 'installationId' | 'session'>

interface ChargingSessionsOverviewProps {
  rfid: string
  storageId: string
  chargingCard: string | null
}

interface WallboxchargingSessionsOverviewProps {
  wallboxId: string
  storageId: string
  wallboxName: string
  wallboxes: WallboxHardwareModel[]
}

interface WallboxTariffsEditorProps {
  wallboxName: string
  storageId: string
  wallboxId: string
  chargePrices: { validFrom: number | null; price: number }[]
  dischargePrices: { validFrom: number | null; price: number }[]
  wallboxIndex: number
  isEdisonConnect: boolean
}

type HotWaterSupplyProps = Pick<HotWaterSupplyDialogProps, 'onConfirm' | 'item'>
interface InstallationStatementProps {
  installation: DeviceInfoForStatement
}

type ExtensionProps = Pick<ExtensionDetailsProps, 'extensionState' | 'hasActiveTariff' | 'isLoading'>

type OpenOStromDetailsProps = Pick<ExtensionDetailsProps, 'loadInstallationExtensionStates' | 'extensionState' | 'hasActiveTariff' | 'isLoading'>

type OpenExtensionDeleteConnectionModalProps = Pick<ExtensionDeleteConnectionModalProps, 'loadInstallationExtensionStates'>

type OpenSmartMeterRecommendationModalProps = Pick<SmartMeterRecommendationModalProps, 'onContinue' | 'tariffType'>

type OpenTibberDetailsProps = Pick<ExtensionDetailsProps, 'loadInstallationExtensionStates' | 'extensionState' | 'hasActiveTariff' | 'isLoading'>

type OpenNotificationMessageProps = Omit<NotificationMessageModalProps, 'onClose' | 'place'>

type CategoryEditorModalProps = Omit<CategoryEditorProps, 'onClose'>

type DownloadItemEditorModalProps = Omit<DownloadItemEditorProps, 'onClose'>

type MoveDownloadItemDialogProps = Omit<MoveDownloadItemEditorProps, 'onClose'>

type TariffDialogProps = {
  installationId: number
  currencySymbol: string | null | undefined
}

type DeleteTariffDialogProps = {
  installationId: number
  tariffId: string
}

type EditTariffModalProps = Pick<EditTariffDialogProps, 'installationId' | 'tariff' | 'tariffId'>

type EditChargingCardDialogProps = {
  chargingCard: ChargingCardModel
}

type AssignTariffDialogProps = {
  wallbox: WallboxModel
  installationId: number
}

type TariffDetailsDialogProps = {
  installationId: number
  tariffId: string
}

interface ChargingSessionDetailsProps {
  session: ChargingSessionModel
  shouldDisplayMidMeter: boolean
}

interface DeleteChargingCardDialogProps {
  ocpiTokenId: string
  installationId: number
  cardName: string | null
  rfid: string
}

type LinkedWallboxesOverviewModalProps = Pick<LinkedWallboxesOverviewDialogProps, 'linkedWallboxes' | 'chargingCard'>
type ChargingCardDetailsDialogProps = Pick<
  ChargingCardDetailsModalProps,
  'chargingCard' | 'installationId' | 'isManagedMode' | 'installationHasWallboxes'
>

interface ChargingCardToWallboxLinkDialogProps {
  installationId: number
}

type UnlinkChargingCardDialogProps = Pick<ManageModeConfirmationDialogProps, 'reset' | 'chargingCards' | 'wallboxes' | 'installationId'>

interface NoDateRangeSelectedExportSessionsDialogProps {
  payload: ExportSessionsPayload
  exportSessions: (payload: ExportSessionsPayload) => void
}

type ReimbursementExportSessionsModalProps = Pick<ReimbursementExportSessionsDialogProps, 'handleExportFile' | 'templateLanguage' | 'currency'>

export interface Modals {
  openUserEditor: ({ userId }: UserProps) => void
  openCompanyEditor: ({ userId }: UserProps) => void
  openPreviewImage: (props: ImagePreviewProps) => void
  openIPinEditor: ({ userId }: IPinEditorProps) => void
  openProjectNameEditor: ({ projectName, setProjectName }: ProjectNameEditorProps) => void
  openActuatorEditor: ({ actuators, onConfirm }: ActuatorEditorProps) => void
  openPasswordEditor: ({ user }: PasswordEditorProps) => void
  openPvModuleEditor: ({ pvModuleId }: PvModuleProps) => void
  openBatteryExportModuleEditor: ({ batteryExportModuleId }: BatteryExportModuleProps) => void
  openConfirmationModal: (props: ConfirmationModalProps) => void
  openInformationModal: (props: InformationModalProps) => void
  openSystemChartEditor: (props: SystemChartProps) => void
  openInstallationAddressEditor: (props: InstallationAddressEditorProps) => void
  openChartLayoutEditor: (props: ChartLayoutEditorProps) => void
  openFarmParticipantSelector: (props: OpenFarmParticipantSelectorProps) => void
  openAssignedUsersEditor: (props: AssignedUsersProps) => void
  openAssignedSystemsEditor: (props: AssignedSystemsProps) => void
  openDocumentCategoryEditor: (props: DocumentCategoryProps) => void
  openInviteEditor: (props: InviteEditorProps) => void
  openInstallationStatementDialog: (props: InstallationStatementProps) => void
  openDocumentEditor: (props: DocumentsProps) => void
  openInstallationDocumentUpload: (props: InstallationDocumentUploadProps) => void
  openAddWallboxDialog: (props: AddWallboxProps) => void
  openLogoutModal: () => void
  openLuoxDirectMarketingModal: (props: ExtensionProps) => void
  openLuoxDynamicTariffModal: (props: ExtensionProps) => void
  openLuoxDynamicTariffDeleteConnectionModal: (props: OpenExtensionDeleteConnectionModalProps) => void
  openInexogyModal: (props: ExtensionProps) => void
  openEonModal: () => void
  openAi360PowerShareModal: (props: ExtensionProps) => void
  openAi360PowerFixModal: (props: ExtensionProps) => void
  openAi360PowerShareDeleteConnectionModal: (props: OpenExtensionDeleteConnectionModalProps) => void
  openAi360PowerFixDeleteConnectionModal: (props: OpenExtensionDeleteConnectionModalProps) => void
  openAi360SmartMeterRecommendationModal: (props: OpenSmartMeterRecommendationModalProps) => void
  openOStromModal: (props: OpenOStromDetailsProps) => void
  openOStromDeleteConnectionModal: (props: OpenExtensionDeleteConnectionModalProps) => void
  openTibberModal: (props: OpenTibberDetailsProps) => void
  openTibberDeleteConnectionModal: (props: OpenExtensionDeleteConnectionModalProps) => void
  openLanguageModal: () => void
  openDeleteProfileDialog: () => void
  openDeleteProfileSurveyDialog: () => void
  openNotificationModal: () => void
  openSmartChargeToggleIdlePeriodDialog: (props: SmartChargeToggleIdlePeriodDialogProps) => void
  openInviteNewAccessToInstallation: (props: InviteNewAccessToInstallationProps) => void
  openSimpleTextDialog: (props: CommonSimpleTextDialogProps) => void
  openInstallationAccessSettings: (props: InstallationAccessSettingsProps) => void
  openShopMoreInfo: (props: ShopMoreInfoModalProps) => void
  openShopLeavingConfirmation: (props: ShopLeavingConfirmationModalModelProps) => void
  openShopCheckoutSideBar: () => void
  openShopPowerMeterModal: () => void
  openShopTransformerModal: (props: ShopTransformerModalProps) => void
  openShopAdditionalProductsModal: (props: ShopAdditionalProductsModalProps) => void
  openShopRetrofitBatteryModal: (props: ShopRetrofitBatteryModalProps) => void
  openHotWaterSupplyDialog: (props: HotWaterSupplyProps) => void
  openShopHintModal: (props: ShopHintModalProps) => void
  openShopBillingAndShippingModal: (props: ShopBillingAndShippingAddressModalProps) => void
  openShopNewShippingAddressModal: (props: ShopNewShippingAddressModalProps) => void
  openShopSaveSystemConfiguration: (props: ShopSaveSystemConfigurationModalProps) => void
  openShopUpdateSystemConfiguration: (props: ShopUpdateSystemConfigurationModalProps) => void
  openShopRetrofitBatterySingleProduct: (props: ShopRetrofitBatterySingleProductModalProps) => void
  openShopOrderHistoryDetails: (props: ShopOrderHistoryDetailsModalProps) => void
  openShopAdminModal: (props: ShopAdminModalProps) => void
  openShopProductImageModal: (props: ShopProductImageModalProps) => void
  openCompanyShowroomModal: (props: CompanyShowroomModalProps) => void
  openRenameInstallationModal: (props: RenameInstallationModalProps) => void
  openNotificationMessageModal: (props: OpenNotificationMessageProps) => void
  openPowerPriceChartModal: (props: PowerPriceChartModalProps) => void
  openManufacturerConnectionTermsDialog: (props: ManufacturerConnectionTermsProps) => void
  openChargeModal: (props: ChargeModalProps) => void
  openAssignManagerDialog: (props: AssignManagerDialogProps) => void
  openShopPromotionCodeModal: (props: ShopPromotionCodeModalProps) => void
  openShopSmartMeterModal: (props: ShopSmartMeterModalProps) => void
  openShopSmartMeterDocumentUploadModal: (props: ShopSmartMeterDocumentUploadModalProps) => void
  openInstallationAccessRequestDialog: (props: InstallationAccessRequestDialogProps) => void
  openOwnerAccessRequestDialog: (props: OwnerAccessRequestDialogProps) => void
  openInstallationAccessRightDialog: (props: InstallationAccessRightDialogProps) => void
  openWallboxWeekDaysDialog: (props: WallboxWeekDaysDialogProps) => void
  openDashboardEditor: (props: DashboardEditorProps) => void
  openCookieModal: (props: CookieModalProps) => void
  openTestRunDetailsModal: (props: TestRunDetailsModalProps) => void
  openChangeInstallationOwnerModal: (props: ChangeInstallationOwnerModalProps) => void
  openEditAccessStartAtModal: (props: EditAccessStartAtModalProps) => void
  openGrantCompanyAccessModal: (props: GrantCompanyAccessModalProps) => void
  openGrantInstallerAccessModal: (props: GrantInstallerAccessModalProps) => void
  openChangeInstallationLocationModal: (props: ChangeLocationDialogProps) => void
  openDynamicTariffSettingsDateRangeModal: (props: DynamicTariffSettingsDateRangeModalProps) => void
  /** New E-Mobility START */
  openAddTariffDialog: (props: TariffDialogProps) => void
  openDeleteTariffDialog: (props: DeleteTariffDialogProps) => void
  openEditTariffDialog: (props: EditTariffModalProps) => void
  openEditChargingCardDialog: (props: EditChargingCardDialogProps) => void
  openAssignTariffDialog: (props: AssignTariffDialogProps) => void
  openTariffDetailsDialog: (props: TariffDetailsDialogProps) => void
  openChargingSessionDetails: (props: ChargingSessionDetailsProps) => void
  openNoDateRangeSelectedExportSessionsDialog: (props: NoDateRangeSelectedExportSessionsDialogProps) => void
  openReimbursementExportSessionsDialog: (props: ReimbursementExportSessionsModalProps) => void
  openDateRangeInvalidExportSessionDialog: () => void
  openDeleteChargingCardDialog: (props: DeleteChargingCardDialogProps) => void
  openLinkedWallboxesOverviewDialog: (props: LinkedWallboxesOverviewModalProps) => void
  openUnmanagedModeOverviewDialog: (props: ChargingCardToWallboxLinkDialogProps) => void
  openChargingCardToWallboxLinkModal: (props: ChargingCardToWallboxLinkDialogProps) => void
  openUnlinkChargingCardsDialog: (props: UnlinkChargingCardDialogProps) => void
  openChargingCardDetailsDialog: (props: ChargingCardDetailsDialogProps) => void
  /** New E-Mobility END */

  /** Old E-Mobility START */
  openWallboxTariffsEditor: (props: WallboxTariffsEditorProps) => void
  openEmobilityChargingCardEditor: (props: EditChargingCardProps) => void
  openChargingSessionDetailsV1: (props: ChargingSessionDetailsV1Props) => void
  openEmobilityExportChargingCardEditor: (props: ExportChargingCardProps) => void
  openChargingSessionsOverview: (props: ChargingSessionsOverviewProps) => void
  openWallboxChargingSessionsOverview: (props: WallboxchargingSessionsOverviewProps) => void
  /** Old E-Mobility END */
  openAmazonCodeModal: (props: AmazonCodeDialogProps) => void
  openDownloadCategoryEditor: (props: CategoryEditorModalProps) => void
  openDeleteCategoryDialog: (prop: DeleteCategoryProps) => void
  openMoveDownloadItemDialog: (props: MoveDownloadItemDialogProps) => void
  openDownloadItemEditor: (props: DownloadItemEditorModalProps) => void
  openUploadFileDialog: (props: UploadFileDialogProps) => void
  /** Flow start */
  openInstallationSaveDialog: (props: InstallationSaveDialogProps) => void
  openInstallationDeleteDialog: (props: InstallationDeleteDialogProps) => void
  openAddDeviceDialog: (props: Omit<AddDeviceDialogProps, 'onClose'>) => void
  openEmcPairingDialog: (props: EmcPairingDialogProps) => void
  openStoragePairingDialog: (props: StoragePairingDialogProps) => void
  openModbusTcpPairingDialog: (props: ModbusTcpPairingDialogProps) => void
  openEebusPairingDialog: (props: EebusPairingDialogProps) => void
  openHeatpumpPairingDialog: (props: HeatpumpPairingDialogProps) => void
  openMeterPairingDialog: (props: MeterPairingDialogProps) => void
  openHtc320hIoPairingDialog: (props: Htc320hIoPairingDialogProps) => void
  openMyPvPairingDialog: (props: MyPvPairingDialogProps) => void
  openActivateModbusTcpServerDialog: (props: ActivateModbusTcpServerDialogProps) => void
  openInstallationPairingDialog: (props: InstallationPairingDialogProps) => void
  openSmartMeterGatewayPairingDialog: (props: SmartMeterGatewayPairingDialogProps) => void
  openEnterOcppPasswordDialog: (props: EnterOcppPasswordDialogProps) => void
  openEditBadgeDialog: (props: EditBadgeDialogProps) => void
  openHoldingTimeEditorDialog: (props: HoldingTimeEditorDialogProps) => void
  openPhaseManagementEditorDialog: (props: PhaseManagementEditorDialogProps) => void
  openChargingScheduleEditorDialog: (props: ChargingScheduleEditorDialogProps) => void
  openBoilerScheduleDialog: (props: BoilerScheduleEditorDialogProps) => void
  openChargingSessionDetailsDialogV1Flow: (props: ChargingSessionDetailsV1FlowProps) => void
  /** Flow ends */

  openReplaceFileDialog: (props: ReplaceFileDialogProps) => void
  openProtectedFileDownloadDialog: (props: ProtectedFileDialogProps) => void
  openUpdateWarrantyDialog: (props: UpdateWarrantyDialogProps) => void
  openReasonDialog: <T extends z.Schema, U = Record<string, never>>(props: ReasonDialogProps<T, U>) => void
  openNewInstallationDialog: () => void
  openScanNetworkForQntmsDialog: (props: ScanNetworkDialogProps) => void
  openPowerMeterScanDialog: (props: PowerMeterScanDialogProps) => void
}

/**
 * custom hook to show modals
 */
const useModals = (): Modals => {
  const dispatch = useDispatch()

  const openChartLayoutEditor = ({ customLayout, defaultAndCustomCharts }: ChartLayoutEditorProps): void => {
    dispatch(addModal({ type: 'chartLayoutEditor', customLayout, defaultAndCustomCharts }))
  }

  const openFarmParticipantSelector = useCallback(
    (props: OpenFarmParticipantSelectorProps): void => {
      dispatch(addModal({ type: 'farmParticipantSelector', ...props }))
    },
    [dispatch]
  )

  const openCompanyEditor = ({ userId }: UserProps): void => {
    dispatch(addModal({ type: 'companyEditor', userId }))
  }

  const openPreviewImage = (props: ImagePreviewProps): void => {
    dispatch(addModal({ type: 'imagePreviewEditor', ...props }))
  }

  const openIPinEditor = ({ userId }: IPinEditorProps): void => {
    dispatch(addModal({ type: 'iPinEditor', userId }))
  }

  const openProjectNameEditor = ({ projectName, setProjectName }: ProjectNameEditorProps): void => {
    dispatch(addModal({ type: 'projectNameEditor', projectName, setProjectName }))
  }

  const openUserEditor = ({ userId }: UserProps): void => {
    dispatch(addModal({ type: 'userEditor', userId }))
  }

  const openActuatorEditor = ({ actuators, onConfirm }: ActuatorEditorProps): void => {
    dispatch(addModal({ type: 'actuatorEditor', actuators, onConfirm }))
  }

  const openPasswordEditor = ({ user }: PasswordEditorProps): void => {
    dispatch(addModal({ type: 'passwordEditor', user }))
  }

  const openPvModuleEditor = ({ pvModuleId }: PvModuleProps): void => {
    dispatch(addModal({ type: 'pvModuleEditor', pvModuleId }))
  }

  const openBatteryExportModuleEditor = ({ batteryExportModuleId }: BatteryExportModuleProps): void => {
    dispatch(addModal({ type: 'batteryExportModuleEditor', batteryExportModuleId }))
  }

  const openConfirmationModal = ({
    text,
    buttonText,
    onConfirm,
    onCancel,
    title,
    isLoading,
    renderAdditionalButtonContent,
    children,
    showChildrenOnTop,
  }: ConfirmationModalProps): void => {
    dispatch(
      addModal({
        type: 'confirmationModal',
        text,
        buttonText,
        onConfirm,
        title,
        isLoading,
        renderAdditionalButtonContent,
        children,
        showChildrenOnTop,
        onCancel,
      })
    )
  }

  const openInformationModal = ({ textKey, buttonText, title }: InformationModalProps): void => {
    dispatch(addModal({ type: 'informationModal', textKey, buttonText, title }))
  }

  const openInstallationAddressEditor = ({ installationId }: InstallationAddressEditorProps): void => {
    dispatch(addModal({ type: 'installationAddressEditor', installationId }))
  }

  const openInstallationDocumentUpload = ({ installationId }: InstallationDocumentUploadProps): void => {
    dispatch(addModal({ type: 'installationDocumentUpload', installationId }))
  }

  const openShopMoreInfo = ({ productId }: ShopMoreInfoModalProps): void => {
    dispatch(addModal({ type: 'shopMoreInfo', productId }))
  }

  const openShopLeavingConfirmation = (props: ShopLeavingConfirmationModalModelProps): void => {
    dispatch(addModal({ type: 'shopLeavingConfirmation', ...props }))
  }

  const openShopCheckoutSideBar = (): void => {
    dispatch(addModal({ type: 'openShopCheckoutSideBar' }))
  }

  const openSystemChartEditor = ({
    chartId,
    chartProps,
    views,
    name,
    ticks,
    handleSaveChart,
    serialNumber,
    loadingState,
  }: SystemChartProps): void => {
    dispatch(addModal({ type: 'systemChartEditor', chartId, chartProps, views, name, ticks, handleSaveChart, serialNumber, loadingState }))
  }

  const openAssignedUsersEditor = ({ companyId }: AssignedUsersProps): void => {
    dispatch(addModal({ type: 'assignedUsers', companyId }))
  }

  const openAssignedSystemsEditor = ({ userId }: AssignedSystemsProps): void => {
    dispatch(addModal({ type: 'assignedSystems', userId }))
  }

  const openInviteEditor = (props: InviteEditorProps): void => {
    dispatch(addModal({ type: 'companyInviteEditor', ...props }))
  }

  const openInstallationStatementDialog = (props: InstallationStatementProps): void => {
    dispatch(addModal({ type: 'installationStatementDialog', ...props }))
  }

  const openDocumentCategoryEditor = (props: DocumentCategoryProps): void => {
    dispatch(addModal({ type: 'documentCategoryEditor', ...props }))
  }

  const openDocumentEditor = (props: DocumentsProps): void => {
    dispatch(addModal({ type: 'documentEditor', ...props }))
  }
  const openAddWallboxDialog = (props: AddWallboxProps): void => {
    dispatch(addModal({ type: 'addWallboxDialog', ...props }))
  }

  const openLogoutModal = (): void => {
    dispatch(addModal({ type: 'logoutModal' }))
  }

  const openLuoxDirectMarketingModal = (props: ExtensionProps): void => {
    dispatch(addModal({ type: 'luoxDirectMarketingModal', ...props }))
  }

  const openLuoxDynamicTariffModal = (props: ExtensionProps): void => {
    dispatch(addModal({ type: 'luoxDynamicTariffModal', ...props }))
  }

  const openLuoxDynamicTariffDeleteConnectionModal = (props: OpenExtensionDeleteConnectionModalProps): void => {
    dispatch(addModal({ type: 'luoxDynamicTariffDeleteConnectionModal', ...props }))
  }

  const openInexogyModal = (props: ExtensionProps): void => {
    dispatch(addModal({ type: 'inexogyModal', ...props }))
  }

  const openEonModal = (): void => {
    dispatch(addModal({ type: 'eonModal' }))
  }

  const openAi360PowerShareModal = (props: ExtensionProps): void => {
    dispatch(addModal({ type: 'ai360PowerShareModal', ...props }))
  }

  const openAi360PowerFixModal = (props: ExtensionProps): void => {
    dispatch(addModal({ type: 'ai360PowerFixModal', ...props }))
  }

  const openAi360PowerShareDeleteConnectionModal = (props: OpenExtensionDeleteConnectionModalProps): void => {
    dispatch(addModal({ type: 'ai360PowerShareDeleteConnectionModal', ...props }))
  }

  const openAi360PowerFixDeleteConnectionModal = (props: OpenExtensionDeleteConnectionModalProps): void => {
    dispatch(addModal({ type: 'ai360PowerFixDeleteConnectionModal', ...props }))
  }

  const openAi360SmartMeterRecommendationModal = (props: OpenSmartMeterRecommendationModalProps): void => {
    dispatch(addModal({ type: 'ai360SmartMeterRecommendationModal', ...props }))
  }

  const openOStromModal = (props: OpenOStromDetailsProps): void => {
    dispatch(addModal({ type: 'oStromModal', ...props }))
  }

  const openOStromDeleteConnectionModal = (props: OpenExtensionDeleteConnectionModalProps): void => {
    dispatch(addModal({ type: 'oStromDeleteConnectionModal', ...props }))
  }

  const openTibberModal = (props: OpenOStromDetailsProps): void => {
    dispatch(addModal({ type: 'tibberModal', ...props }))
  }

  const openTibberDeleteConnectionModal = (props: OpenExtensionDeleteConnectionModalProps): void => {
    dispatch(addModal({ type: 'tibberDeleteConnectionModal', ...props }))
  }

  const openLanguageModal = (): void => {
    dispatch(addModal({ type: 'languageModal' }))
  }

  const openDeleteProfileDialog = (): void => {
    dispatch(addModal({ type: 'deleteProfileDialog' }))
  }

  const openDeleteProfileSurveyDialog = (): void => {
    dispatch(addModal({ type: 'userDeletionSurvey' }))
  }

  const openNotificationModal = (): void => {
    dispatch(addModal({ type: 'notificationModal' }))
  }

  const openSmartChargeToggleIdlePeriodDialog = (props: SmartChargeToggleIdlePeriodDialogProps): void => {
    dispatch(addModal({ type: 'smartChargeToggleIdlePeriodDialog', ...props }))
  }
  const openInviteNewAccessToInstallation = (props: InviteNewAccessToInstallationProps): void => {
    dispatch(addModal({ type: 'installationAccessInviteDialog', ...props }))
  }
  const openInstallationAccessSettings = (props: InstallationAccessSettingsProps): void => {
    dispatch(addModal({ type: 'installationAccessSettingsDialog', ...props }))
  }

  const openSimpleTextDialog = (props: CommonSimpleTextDialogProps): void => {
    dispatch(addModal({ type: 'simpleTextDialog', ...props }))
  }

  const openHotWaterSupplyDialog = (props: HotWaterSupplyProps): void => {
    dispatch(addModal({ type: 'hotWaterSupplyDialog', ...props }))
  }
  const openShopNewShippingAddressModal = (props: ShopNewShippingAddressModalProps): void => {
    dispatch(addModal({ type: 'shopNewShippingAddressModal', ...props }))
  }

  const openShopPowerMeterModal = (): void => {
    dispatch(addModal({ type: 'openShopPowerMeter' }))
  }

  const openShopTransformerModal = (props: ShopTransformerModalProps): void => {
    dispatch(addModal({ type: 'openShopTransformerModal', ...props }))
  }

  const openShopAdditionalProductsModal = (props: ShopAdditionalProductsModalProps): void => {
    dispatch(addModal({ type: 'openShopAdditionalProductsModal', ...props }))
  }

  const openShopRetrofitBatteryModal = (props: ShopRetrofitBatteryModalProps): void => {
    dispatch(addModal({ type: 'openShopRetrofitBatteryModal', ...props }))
  }

  const openShopHintModal = (props: ShopHintModalProps): void => {
    dispatch(addModal({ type: 'shopHintModal', ...props }))
  }

  const openShopBillingAndShippingModal = (props: ShopBillingAndShippingAddressModalProps): void => {
    dispatch(addModal({ type: 'shopBillingAndShippingModal', ...props }))
  }

  const openShopSaveSystemConfiguration = (props: ShopSaveSystemConfigurationModalProps): void => {
    dispatch(addModal({ type: 'shopSaveSystemConfiguration', ...props }))
  }
  const openShopUpdateSystemConfiguration = (props: ShopUpdateSystemConfigurationModalProps): void => {
    dispatch(addModal({ type: 'shopUpdateSystemConfiguration', ...props }))
  }
  const openShopRetrofitBatterySingleProduct = (props: ShopRetrofitBatterySingleProductModalProps): void => {
    dispatch(addModal({ type: 'shopRetrofitBatterySingleProduct', ...props }))
  }
  const openShopOrderHistoryDetails = (props: ShopOrderHistoryDetailsModalProps): void => {
    dispatch(addModal({ type: 'shopOrderHistoryDetails', ...props }))
  }
  const openShopAdminModal = ({ onConfirm }: ShopAdminModalProps): void => {
    dispatch(addModal({ type: 'shopAdminModal', onConfirm }))
  }
  const openShopProductImageModal = (props: ShopProductImageModalProps): void => {
    dispatch(addModal({ type: 'shopProductImageModal', ...props }))
  }

  const openCompanyShowroomModal = (props: CompanyShowroomModalProps): void => {
    dispatch(addModal({ type: 'companyShowroomModal', ...props }))
  }

  const openRenameInstallationModal = (props: RenameInstallationModalProps): void => {
    dispatch(addModal({ type: 'renameInstallationModal', ...props }))
  }

  const openNotificationMessageModal = (props: OpenNotificationMessageProps): void => {
    dispatch(addModal({ type: 'notificationMessageModal', ...props }))
  }

  const openPowerPriceChartModal = (props: PowerPriceChartModalProps): void => {
    dispatch(addModal({ type: 'powerPriceChartModal', ...props }))
  }

  const openManufacturerConnectionTermsDialog = (props: ManufacturerConnectionTermsProps): void => {
    dispatch(addModal({ type: 'manufacturerConnectionTermsDialog', ...props }))
  }

  const openChargeModal = (props: ChargeModalProps): void => {
    dispatch(addModal({ type: 'chargeModal', ...props }))
  }

  const openAssignManagerDialog = (props: AssignManagerDialogProps): void => {
    dispatch(addModal({ type: 'assignManagerDialog', ...props }))
  }

  const openShopPromotionCodeModal = (props: ShopPromotionCodeModalProps): void => {
    dispatch(addModal({ type: 'shopPromotionCodeModal', ...props }))
  }

  const openShopSmartMeterModal = (props: ShopSmartMeterModalProps): void => {
    dispatch(addModal({ type: 'shopSmartMeterModal', ...props }))
  }

  const openShopSmartMeterDocumentUploadModal = (props: ShopSmartMeterDocumentUploadModalProps): void => {
    dispatch(addModal({ type: 'shopSmartMeterDocumentUploadModal', ...props }))
  }

  const openInstallationAccessRequestDialog = (props: InstallationAccessRequestDialogProps): void => {
    dispatch(addModal({ type: 'installationAccessRequestDialog', ...props }))
  }

  const openOwnerAccessRequestDialog = (props: OwnerAccessRequestDialogProps): void => {
    dispatch(addModal({ type: 'ownerAccessRequestDialog', ...props }))
  }

  const openInstallationAccessRightDialog = (props: InstallationAccessRightDialogProps): void => {
    dispatch(addModal({ type: 'installationAccessRightDialog', ...props }))
  }

  const openWallboxWeekDaysDialog = (props: WallboxWeekDaysDialogProps): void => {
    dispatch(addModal({ type: 'wallboxWeekDaysDialog', ...props }))
  }

  const openDashboardEditor = (props: DashboardEditorProps): void => {
    dispatch(addModal({ type: 'dashboardEditor', ...props }))
  }

  const openCookieModal = (props: CookieModalProps): void => {
    dispatch(addModal({ type: 'cookieModal', ...props }))
  }

  const openTestRunDetailsModal = (props: TestRunDetailsModalProps): void => {
    dispatch(addModal({ type: 'testRunDetailsModal', ...props }))
  }

  const openChangeInstallationOwnerModal = (props: ChangeInstallationOwnerModalProps): void => {
    dispatch(addModal({ type: 'changeInstallationOwnerModal', ...props }))
  }

  const openEditAccessStartAtModal = (props: EditAccessStartAtModalProps): void => {
    dispatch(addModal({ type: 'editAccessStartAtModal', ...props }))
  }

  const openGrantCompanyAccessModal = (props: GrantCompanyAccessModalProps): void => {
    dispatch(addModal({ type: 'grantCompanyAccessModal', ...props }))
  }

  const openGrantInstallerAccessModal = (props: GrantInstallerAccessModalProps): void => {
    dispatch(addModal({ type: 'grantInstallerAccessModal', ...props }))
  }

  const openChangeInstallationLocationModal = (props: ChangeLocationDialogProps): void => {
    dispatch(addModal({ type: 'changeInstallationLocationModal', ...props }))
  }

  const openDynamicTariffSettingsDateRangeModal = (props: DynamicTariffSettingsDateRangeModalProps): void => {
    dispatch(addModal({ type: 'dynamicTariffSettingsDateRangeModal', ...props }))
  }

  const openAmazonCodeModal = (props: AmazonCodeDialogProps): void => {
    dispatch(addModal({ type: 'amazonCodeModal', ...props }))
  }

  const openDownloadCategoryEditor = (props: CategoryEditorModalProps): void => {
    dispatch(addModal({ type: 'downloadCategoryEditor', ...props }))
  }

  const openDeleteCategoryDialog = (props: DeleteCategoryProps): void => {
    dispatch(addModal({ type: 'deleteCategoryDialog', ...props }))
  }

  const openMoveDownloadItemDialog = (props: MoveDownloadItemDialogProps): void => {
    dispatch(addModal({ type: 'moveDownloadItemDialog', ...props }))
  }

  const openDownloadItemEditor = (props: DownloadItemEditorModalProps): void => {
    dispatch(addModal({ type: 'downloadItemEditor', ...props }))
  }

  const openUploadFileDialog = (props: UploadFileDialogProps): void => {
    dispatch(addModal({ type: 'uploadFileDialog', ...props }))
  }
  const openInstallationSaveDialog = (props: InstallationSaveDialogProps): void => {
    dispatch(addModal({ type: 'openInstallationSaveDialog', ...props }))
  }

  const openInstallationDeleteDialog = (props: InstallationDeleteDialogProps): void => {
    dispatch(addModal({ type: 'openInstallationDeleteDialog', ...props }))
  }

  const openAddDeviceDialog = (props: Omit<AddDeviceDialogProps, 'onClose'>): void => {
    dispatch(addModal({ type: 'addDeviceDialog', ...props }))
  }

  const openEmcPairingDialog = (props: EmcPairingDialogProps): void => {
    dispatch(addModal({ type: 'emcPairingDialog', ...props }))
  }

  const openStoragePairingDialog = (props: StoragePairingDialogProps): void => {
    dispatch(addModal({ type: 'storagePairingDialog', ...props }))
  }

  const openModbusTcpPairingDialog = (props: ModbusTcpPairingDialogProps): void => {
    dispatch(addModal({ type: 'modbusTcpPairingDialog', ...props }))
  }

  const openEebusPairingDialog = (props: EebusPairingDialogProps): void => {
    dispatch(addModal({ type: 'eebusPairingDialog', ...props }))
  }

  const openHeatpumpPairingDialog = (props: HeatpumpPairingDialogProps): void => {
    dispatch(addModal({ type: 'heatpumpPairingDialog', ...props }))
  }

  const openMeterPairingDialog = (props: MeterPairingDialogProps): void => {
    dispatch(addModal({ type: 'meterPairingDialog', ...props }))
  }

  const openHtc320hIoPairingDialog = (props: Htc320hIoPairingDialogProps): void => {
    dispatch(addModal({ type: 'htc320hIoPairingDialog', ...props }))
  }

  const openMyPvPairingDialog = (props: MyPvPairingDialogProps): void => {
    dispatch(addModal({ type: 'myPvPairingDialog', ...props }))
  }

  const openActivateModbusTcpServerDialog = (props: ActivateModbusTcpServerDialogProps): void => {
    dispatch(addModal({ type: 'activateModbusTcpServerDialog', ...props }))
  }

  const openInstallationPairingDialog = (props: InstallationPairingDialogProps): void => {
    dispatch(addModal({ type: 'installationPairingDialog', ...props }))
  }

  const openSmartMeterGatewayPairingDialog = (props: SmartMeterGatewayPairingDialogProps): void => {
    dispatch(addModal({ type: 'smartMeterGatewayPairingDialog', ...props }))
  }

  const openEnterOcppPasswordDialog = (props: EnterOcppPasswordDialogProps): void => {
    dispatch(addModal({ type: 'enterOcppPasswordDialog', ...props }))
  }

  const openEditBadgeDialog = (props: EditBadgeDialogProps): void => {
    dispatch(addModal({ type: 'editBadgeDialog', ...props }))
  }

  const openHoldingTimeEditorDialog = (props: HoldingTimeEditorDialogProps): void => {
    dispatch(addModal({ type: 'holdingTimeEditorDialog', ...props }))
  }
  const openPhaseManagementEditorDialog = (props: PhaseManagementEditorDialogProps): void => {
    dispatch(addModal({ type: 'phaseManagementEditorDialog', ...props }))
  }

  const openChargingScheduleEditorDialog = (props: ChargingScheduleEditorDialogProps): void => {
    dispatch(addModal({ type: 'chargingScheduleEditorDialog', ...props }))
  }

  const openBoilerScheduleDialog = (props: BoilerScheduleEditorDialogProps): void => {
    dispatch(addModal({ type: 'boilerScheduleDialog', ...props }))
  }

  const openProtectedFileDownloadDialog = (props: ProtectedFileDialogProps): void => {
    dispatch(addModal({ type: 'protectedFileDownloadDialog', ...props }))
  }

  /** New E-Mobility START */
  const openAddTariffDialog = ({ installationId, currencySymbol }: TariffDialogProps): void => {
    dispatch(addModal({ type: 'addTariffDialog', installationId, currencySymbol }))
  }

  const openDeleteTariffDialog = ({ installationId, tariffId }: DeleteTariffDialogProps): void => {
    dispatch(addModal({ type: 'deleteTariffDialog', installationId, tariffId }))
  }
  const openEditTariffDialog = (props: EditTariffModalProps): void => {
    dispatch(addModal({ type: 'editTariffDialog', ...props }))
  }

  const openEditChargingCardDialog = ({ chargingCard }: EditChargingCardDialogProps): void => {
    dispatch(addModal({ type: 'editChargingCardDialog', chargingCard }))
  }

  const openAssignTariffDialog = ({ wallbox, installationId }: AssignTariffDialogProps): void => {
    dispatch(addModal({ type: 'assignTariffDialog', wallbox, installationId }))
  }

  const openTariffDetailsDialog = (props: TariffDetailsDialogProps): void => {
    dispatch(addModal({ type: 'tariffDetailsDialog', ...props }))
  }

  const openChargingSessionDetails = (props: ChargingSessionDetailsProps): void => {
    dispatch(addModal({ type: 'chargingSessionDetails', ...props }))
  }

  const openNoDateRangeSelectedExportSessionsDialog = (props: NoDateRangeSelectedExportSessionsDialogProps): void => {
    dispatch(addModal({ type: 'noDateRangeSelectedExportSessions', ...props }))
  }

  const openReimbursementExportSessionsDialog = (props: ReimbursementExportSessionsModalProps): void => {
    dispatch(addModal({ type: 'reimbursementExportSessions', ...props }))
  }

  const openDateRangeInvalidExportSessionDialog = (): void => {
    dispatch(addModal({ type: 'invalidDateRangeSelectedExportSessions' }))
  }

  const openDeleteChargingCardDialog = (props: DeleteChargingCardDialogProps): void => {
    dispatch(addModal({ type: 'deleteChargingCard', ...props }))
  }

  const openLinkedWallboxesOverviewDialog = (props: LinkedWallboxesOverviewModalProps): void => {
    dispatch(addModal({ type: 'linkedWallboxesOverview', ...props }))
  }

  const openUnmanagedModeOverviewDialog = (props: ChargingCardToWallboxLinkDialogProps): void => {
    dispatch(addModal({ type: 'unmanagedModeOverview', ...props }))
  }

  const openUnlinkChargingCardsDialog = (props: UnlinkChargingCardDialogProps): void => {
    dispatch(addModal({ type: 'unlinkChargingCards', ...props }))
  }

  const openChargingCardToWallboxLinkModal = (props: ChargingCardToWallboxLinkDialogProps): void => {
    dispatch(addModal({ type: 'chargingCardToWallboxLinkModal', ...props }))
  }

  const openChargingCardDetailsDialog = (props: ChargingCardDetailsDialogProps): void => {
    dispatch(addModal({ type: 'chargingCardDetailsDialog', ...props }))
  }
  /** New E-Mobility END */

  /** Old E-Mobility START */
  const openChargingSessionDetailsV1 = (props: ChargingSessionDetailsV1Props): void => {
    dispatch(addModal({ type: 'chargingSessionDetailsV1', ...props }))
  }

  const openChargingSessionsOverview = ({ rfid, storageId, chargingCard }: ChargingSessionsOverviewProps): void => {
    dispatch(addModal({ type: 'chargingSessionsOverview', rfid, storageId, chargingCard }))
  }

  const openWallboxChargingSessionsOverview = ({ wallboxId, storageId, wallboxName, wallboxes }: WallboxchargingSessionsOverviewProps): void => {
    dispatch(addModal({ type: 'wallboxChargingSessionsOverview', wallboxId, storageId, wallboxName, wallboxes }))
  }

  const openWallboxTariffsEditor = ({
    wallboxId,
    storageId,
    chargePrices,
    dischargePrices,
    wallboxName,
    wallboxIndex,
    isEdisonConnect,
  }: WallboxTariffsEditorProps): void => {
    dispatch(
      addModal({ type: 'wallboxTariffsEditor', wallboxId, storageId, chargePrices, dischargePrices, wallboxName, wallboxIndex, isEdisonConnect })
    )
  }

  const openEmobilityChargingCardEditor = ({ data, serialNo }: EditChargingCardProps): void => {
    dispatch(addModal({ type: 'emobilityChargingCardEditor', data, serialNo }))
  }

  const openEmobilityExportChargingCardEditor = ({ rfid, vehicleName, chargingCard, storageId }: ExportChargingCardProps): void => {
    dispatch(addModal({ type: 'emobilityExportChargingCardEditor', rfid, vehicleName, chargingCard, storageId }))
  }

  const openChargingSessionDetailsDialogV1Flow = ({ installationId, session }: ChargingSessionDetailsV1FlowProps): void => {
    dispatch(addModal({ type: 'chargingSessionDetailsDialogV1Flow', installationId, session }))
  }
  /** Old E-Mobility END */

  const openReplaceFileDialog = (props: ReplaceFileDialogProps): void => {
    dispatch(addModal({ type: 'replaceFileDialog', ...props }))
  }

  const openUpdateWarrantyDialog = (props: UpdateWarrantyDialogProps): void => {
    dispatch(addModal({ type: 'updateWarrantyDialog', ...props }))
  }

  const openReasonDialog = <T extends z.Schema, U = Record<string, never>>(props: ReasonDialogProps<T, U>): void => {
    dispatch(addModal({ type: 'reasonDialog', ...props }))
  }

  const openNewInstallationDialog = (): void => {
    dispatch(addModal({ type: 'newInstallationDialog' }))
  }

  const openScanNetworkForQntmsDialog = (props: ScanNetworkDialogProps): void => {
    dispatch(addModal({ type: 'scanNetworkForQntmsDialog', ...props }))
  }

  const openPowerMeterScanDialog = (props: PowerMeterScanDialogProps): void => {
    dispatch(addModal({ type: 'powerMeterScanDialog', ...props }))
  }

  return {
    openUserEditor,
    openActuatorEditor,
    openPasswordEditor,
    openPvModuleEditor,
    openBatteryExportModuleEditor,
    openConfirmationModal,
    openInformationModal,
    openSystemChartEditor,
    openInstallationAddressEditor,
    openIPinEditor,
    openProjectNameEditor,
    openCompanyEditor,
    openPreviewImage,
    openChartLayoutEditor,
    openFarmParticipantSelector,
    openAssignedUsersEditor,
    openAssignedSystemsEditor,
    openInviteEditor,
    openInstallationStatementDialog,
    openDocumentCategoryEditor,
    openDocumentEditor,
    openInstallationDocumentUpload,
    openAddWallboxDialog,
    openLogoutModal,
    openLuoxDirectMarketingModal,
    openLuoxDynamicTariffModal,
    openLuoxDynamicTariffDeleteConnectionModal,
    openInexogyModal,
    openEonModal,
    openAi360PowerShareModal,
    openAi360PowerFixModal,
    openAi360PowerShareDeleteConnectionModal,
    openAi360PowerFixDeleteConnectionModal,
    openAi360SmartMeterRecommendationModal,
    openOStromModal,
    openOStromDeleteConnectionModal,
    openTibberModal,
    openTibberDeleteConnectionModal,
    openLanguageModal,
    openDeleteProfileDialog,
    openDeleteProfileSurveyDialog,
    openNotificationModal,
    openSmartChargeToggleIdlePeriodDialog,
    openInviteNewAccessToInstallation,
    openSimpleTextDialog,
    openInstallationAccessSettings,
    openShopMoreInfo,
    openShopLeavingConfirmation,
    openShopCheckoutSideBar,
    openShopPowerMeterModal,
    openShopTransformerModal,
    openShopAdditionalProductsModal,
    openShopRetrofitBatteryModal,
    openHotWaterSupplyDialog,
    openShopHintModal,
    openShopBillingAndShippingModal,
    openShopNewShippingAddressModal,
    openShopSaveSystemConfiguration,
    openShopUpdateSystemConfiguration,
    openShopRetrofitBatterySingleProduct,
    openShopOrderHistoryDetails,
    openShopAdminModal,
    openShopProductImageModal,
    openCompanyShowroomModal,
    openRenameInstallationModal,
    openNotificationMessageModal,
    openPowerPriceChartModal,
    openManufacturerConnectionTermsDialog,
    openChargeModal,
    openAssignManagerDialog,
    openShopPromotionCodeModal,
    openShopSmartMeterModal,
    openShopSmartMeterDocumentUploadModal,
    openInstallationAccessRequestDialog,
    openOwnerAccessRequestDialog,
    openInstallationAccessRightDialog,
    openWallboxWeekDaysDialog,
    openDashboardEditor,
    openCookieModal,
    openTestRunDetailsModal,
    openChangeInstallationOwnerModal,
    openEditAccessStartAtModal,
    openGrantCompanyAccessModal,
    openGrantInstallerAccessModal,
    openChangeInstallationLocationModal,
    openDynamicTariffSettingsDateRangeModal,
    openAmazonCodeModal,
    openDownloadCategoryEditor,
    openDeleteCategoryDialog,
    openMoveDownloadItemDialog,
    openDownloadItemEditor,
    openUploadFileDialog,
    /** Old E-Mobility START */
    openAddTariffDialog,
    openDeleteTariffDialog,
    openEditTariffDialog,
    openEditChargingCardDialog,
    openAssignTariffDialog,
    openTariffDetailsDialog,
    openChargingSessionDetails,
    openNoDateRangeSelectedExportSessionsDialog,
    openDateRangeInvalidExportSessionDialog,
    openDeleteChargingCardDialog,
    openLinkedWallboxesOverviewDialog,
    openUnmanagedModeOverviewDialog,
    openReimbursementExportSessionsDialog,
    openChargingCardToWallboxLinkModal,
    openUnlinkChargingCardsDialog,
    openChargingCardDetailsDialog,
    /** Old E-Mobility END */
    /** Old E-Mobility START */
    openWallboxTariffsEditor,
    openEmobilityChargingCardEditor,
    openChargingSessionDetailsV1,
    openEmobilityExportChargingCardEditor,
    openChargingSessionsOverview,
    openWallboxChargingSessionsOverview,
    /** Old E-Mobility END */
    /** Flow start */
    openInstallationSaveDialog,
    openInstallationDeleteDialog,
    openAddDeviceDialog,
    openEmcPairingDialog,
    openStoragePairingDialog,
    openModbusTcpPairingDialog,
    openEebusPairingDialog,
    openHeatpumpPairingDialog,
    openMeterPairingDialog,
    openHtc320hIoPairingDialog,
    openMyPvPairingDialog,
    openActivateModbusTcpServerDialog,
    openInstallationPairingDialog,
    openSmartMeterGatewayPairingDialog,
    openEnterOcppPasswordDialog,
    openEditBadgeDialog,
    openHoldingTimeEditorDialog,
    openPhaseManagementEditorDialog,
    openChargingScheduleEditorDialog,
    openBoilerScheduleDialog,
    openChargingSessionDetailsDialogV1Flow,
    /** Flow ends */
    openReplaceFileDialog,
    openProtectedFileDownloadDialog,
    openReasonDialog,
    openUpdateWarrantyDialog,
    openNewInstallationDialog,
    openScanNetworkForQntmsDialog,
    openPowerMeterScanDialog,
  }
}

export default useModals
